import { render, staticRenderFns } from "./AddNewContact.vue?vue&type=template&id=15c1b2c6&scoped=true&"
import script from "./AddNewContact.vue?vue&type=script&lang=js&"
export * from "./AddNewContact.vue?vue&type=script&lang=js&"
import style0 from "./AddNewContact.vue?vue&type=style&index=0&id=15c1b2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1b2c6",
  null
  
)

export default component.exports